import { Component, OnInit, Input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-support',
    imports: [
        TranslocoPipe,
        CommonModule
    ],
    templateUrl: './support.component.html',
    styleUrls: ['./support.component.css'],
    standalone: true
})
export class SupportComponent implements OnInit {
	@Input('emergency') isEmergency: boolean = false;

	constructor(public activeModal: NgbActiveModal) { }

	ngOnInit(): void { }
}
